import gql from 'graphql-tag';

export const UPDATE_CURRENT_STAGE_FOR_DEPARTMENT = gql`
  mutation UpdateCurrentStageForDepartment($input: UpdateCurrentStageForDepartmentInput!) {
    bpf {
      result: updateCurrentStageForDepartment(input: $input) {
        error
        success
      }
    }
  }
`;
